import { render, staticRenderFns } from "./SequenceList.vue?vue&type=template&id=12ae4095&"
import script from "./SequenceList.vue?vue&type=script&lang=ts&"
export * from "./SequenceList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports